export default __webpack_public_path__ + "static/media/misc-books4-768w.72dc4ed2.png";